import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Spin,
  Tag,
  Row,
  Col,
  Button,
  Space,
  Breadcrumb,
  Divider,
  Typography,
  Flex,
} from "antd";

import { useSelector, dispatch } from "../../../redux/store";
import { getByFlowerId } from "../../../redux/action/flower";

const { Title, Paragraph, Text } = Typography;

export default function ProductDetail() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(0);

  const { flowerDetail } = useSelector((state) => state.flower);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        await dispatch(getByFlowerId(Number(id)));
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, [id]);

  if (loading)
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          minHeight: "60vh",
          alignItems: "center",
        }}
      >
        <Spin size="large" tip="Đang tải..." />
      </div>
    );

  if (!flowerDetail)
    return (
      <div style={{ textAlign: "center", padding: "60px 20px" }}>
        <Title level={3}>Không tìm thấy sản phẩm</Title>
      </div>
    );

  const flower = flowerDetail;
  const images = flower.images || [];

  return (
    <div
      style={{
        marginBlock: 32,
        paddingBlock: 20,
        boxShadow: "0 2px 12px rgba(0,0,0,0.1)",
        background: "#fff",
        borderRadius: 16,
      }}
    >
      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 20px" }}>
        <Row gutter={[24, 24]}>
          <Col xs={24} md={10}>
            <div style={{ position: "sticky", top: 20 }}>
              <div
                style={{
                  borderRadius: 12,
                  overflow: "hidden",
                  marginBottom: 12,
                  background: "#fafafa",
                }}
              >
                {images.length > 0 ? (
                  <img
                    src={images[selectedImage]?.imageUrl}
                    alt={flower.name}
                    style={{ width: "100%", height: 400, objectFit: "cover" }}
                  />
                ) : (
                  <div
                    style={{
                      height: 400,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#999",
                    }}
                  >
                    Chưa có hình ảnh
                  </div>
                )}
              </div>

              {images.length > 1 && (
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  {images.map((img, idx) => (
                    <div
                      key={idx}
                      onClick={() => setSelectedImage(idx)}
                      style={{
                        width: 80,
                        height: 80,
                        border:
                          selectedImage === idx
                            ? "2px solid #1890ff"
                            : "1px solid #e0e0e0",
                        borderRadius: 8,
                        overflow: "hidden",
                        cursor: "pointer",
                      }}
                    >
                      <img
                        src={img.imageUrl}
                        alt={`${flower.name} ${idx + 1}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </Col>

          {/* Right: Info & Form */}
          <Col xs={24} md={14}>
            <div style={{ padding: 24, borderRadius: 12 }}>
              <Breadcrumb>
                <Breadcrumb.Item onClick={() => navigate("/")}>
                  Trang chủ
                </Breadcrumb.Item>
                <Breadcrumb.Item>{flower.groupName}</Breadcrumb.Item>
                <Breadcrumb.Item>{flower.name}</Breadcrumb.Item>
              </Breadcrumb>

              {/* Header */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
              >
                <Flex
                  justify="space-between"
                  align="center"
                  style={{ width: "100%" }}
                >
                  <div>
                    <Title level={2} style={{margin:"10px 0"}}>{flower.name}</Title>
                    {flower.price && (
                      <Text delete style={{ fontSize: 16, color: "#999" }}>
                        {flower.price}
                      </Text>
                    )}
                    <Tag color="green">{flower.groupName}</Tag>
                  </div>

                  <Button type="primary" onClick={() => navigate(`/Product/Data/Update/${flower.flowerId}`)}>Chỉnh sửa</Button>
                </Flex>
              </div>

              <Divider />

              {/* Flower Info */}
              <Space direction="vertical" size={16} style={{ width: "100%" }}>
                <div>
                  <Text type="secondary">Tuổi thọ:</Text>
                  <br />
                  <Text strong>{flower.lifespan}</Text>
                </div>
                <div>
                  <Text type="secondary">Xuất xứ:</Text>
                  <br />
                  <Text strong>{flower.origin}</Text>
                </div>
                <div>
                  <Text type="secondary">Đặc điểm:</Text>
                  <br />
                  <Text>{flower.feature}</Text>
                </div>
                <div>
                  <Text type="secondary">Ý nghĩa:</Text>
                  <br />
                  <Text>{flower.meaning}</Text>
                </div>
                <div>
                  <Text type="secondary">Mô tả chi tiết:</Text>
                  <Paragraph style={{ margin: 0 }}>
                    {flower.description}
                  </Paragraph>
                </div>
              </Space>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}
